/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import Datetime from 'react-datetime';
import moment from 'moment';

import { CalendarIcon } from '@heroicons/react/solid';

import 'react-datetime/css/react-datetime.css';

export interface IDatePickerProps {
  id: string;
  label?: string;
  value?: string;
  required?: boolean;
  placeholder?: string;
  onCompChange?(id: string, payload: any): void;
  item?: any;
}

export const DatePicker = ({
  id,
  label,
  value,
  required,
  placeholder,
  onCompChange,
  item,
}: IDatePickerProps) => {
  const [textValue, setTextValue] = useState(value ?? '');
  const onChange = (id: string, e: any) => {
    setTextValue(e);
    onCompChange && onCompChange(item, id, moment(e).format('DD/MM/YYYY'));
  };
  const _renderLabelIf = () => {
    if (label) {
      let _newLabel = required ? (
        <p>
          {label}
          <sup style={{ color: 'red' }}>*</sup>
        </p>
      ) : (
        label
      );
      return <Form.Label>{_newLabel}</Form.Label>;
    }
    return null;
  };

  return (
    <>
      <Form.Group id={id} className="mb-4">
        {_renderLabelIf()}
        <Datetime
          timeFormat={false}
          closeOnSelect={true}
          dateFormat="DD/MM/YYYY"
          onChange={onChange.bind(null, id)}
          renderInput={(props, openCalendar) => (
            <InputGroup>
              <InputGroup.Text>
                <CalendarIcon className="icon icon-xs" />
              </InputGroup.Text>
              <Form.Control
                required={required}
                type="text"
                value={textValue ? moment(textValue).format('DD/MM/YYYY') : ''}
                placeholder="mm/dd/yyyy"
                onFocus={openCalendar}
                onChange={() => {}}
              />
            </InputGroup>
          )}
        />
      </Form.Group>
    </>
  );
};

DatePicker.defaultProps = {
  required: false,
};
